import { useContext } from "react";
import { SessionContext } from "@/context-providers/SessionContext";

export const useSession = () => {
  const sessionContext = useContext(SessionContext);
  return sessionContext;
};
